export default "__VITE_ASSET__Cvu9n1$8__"